import { render, staticRenderFns } from "./SponsorCategoryForm.vue?vue&type=template&id=69e74efa"
import script from "./SponsorCategoryForm.vue?vue&type=script&lang=js"
export * from "./SponsorCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports